import { BikeIcon, BusIcon, CarIcon, WalkIcon } from './icons';
export var ROUTE_ICONS_BY_TYPE = new Map([['pedestrian', WalkIcon], ['driving', CarIcon], ['masstransit', BusIcon], ['bicycle', BikeIcon]]);